import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import SmsListItemsList from "./views/SmsListItemsList";
import * as listItemsSmsActions from "../../../../redux/modules/list-items-sms";
import * as optionsActions from "../../../../redux/modules/options";

const mapStateToProps = state => {
  return {
    loading: state.listItemsSms.loading,
    success: state.listItemsSms.success,
    message: state.listItemsSms.message,
    data: state.listItemsSms.data,
    total: state.listItemsSms.total,
    limit: state.listItemsSms.limit,
    page: state.listItemsSms.page,
    order: state.listItemsSms.order,
    orderMode: state.listItemsSms.orderMode,
    deleted: state.listItemsSms.deleted,
    deletedId: state.listItemsSms.deletedId,
    token: state.listItemsSms.token,

    headerLoaded: state.options.headerLoaded,
    translate: state.options.translate,
    searchModel: state.options.searchModel,
    columns: state.options.columns,
    columnsOrder: state.options.columnsOrder
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getListHeader: optionsActions.getGridInfo,
      optionsReset: optionsActions.reset,

      getList: listItemsSmsActions.SmsListItemList,
      delete: listItemsSmsActions.SmsListItemDelete,
      setLoading: listItemsSmsActions.setLoading,
      reset: listItemsSmsActions.reset
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SmsListItemsList);



// WEBPACK FOOTER //
// ./src/Containers/Pages/Sms/SmsListItems/SmsListItemsList.js